export enum WinLoss {
  Draw = 0,
  Win = 1,
  Loss = -1
}